/**
 * @Description: "设备管理接口请求"
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors:   YOYO [792611446@qq.com]
 * @Date:   2020-11-16 17:18:31
 * @LastEditTime: 2020-11-25 16:37:11
 */

import { post, get } from '@/utils/request'

/**
 * @description   顶部数据统计
 * @param {*} params
 */
export async function getTopData () {
  return get('/rest/statisticsEquipStatusNum')
}
/**
 * @description   统计保养次数
 * @param {*} params
 */
export async function statisticsEquipMaintainNum (params) {
  return get('/rest/statisticsEquipMaintainNum', params)
}
/**
 * @description   统计保养设备类型
 * @param {*} params
 */
export async function equipMaintainType (params) {
  return get('/rest/equipMaintainType', params)
}
/**
 * @description   统计报废设备量
 * @param {*} params
 */
export async function statisticsScrapNum (params) {
  return get('/rest/statisticsScrapNum', params)
}
/**
 * @description   统计报废设备类型
 * @param {*} params
 */
export async function statisticsScrapType (params) {
  return get('/rest/statisticsScrapType', params)
}

export const OPTIONBAR = {
  title: {
    text: '保养设备数量统计',
    textStyle: {
      color: '#666',
      fontSize: 18,
    },
    left: '7%',
    top: '5%',
  },
  color: ['#3ba1ff', '#edbf00'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  // legend: {
  //   data: ['直接访问'],
  //   itemWidth: 12,
  //   itemHeight: 12,
  //   right: '8%',
  //   top: '14%',
  // },
  grid: {
    top: '25%',
    left: '7%',
    right: '8%',
    bottom: '10%',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisLine: {
        lineStyle: {
          color: '#ccc',
        },
      },
      axisLabel: {
        color: '#666',
      },
    },
  ],
  yAxis: [
    {
      name: '次',
      nameTextStyle: { color: '#3ba1ff' },
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: { show: false },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#e7e7e7',
        },
      },
      axisLabel: {
        color: '#666',
      },
    },
  ],
  series: [
    {
      name: '',
      type: 'bar',
      data: [],
      barMaxWidth: 15,
    },
  ],
}
export const OPTIONPIE = {
  title: {
    text: '保养设备数量统计',
    textStyle: {
      color: '#666',
      fontSize: 18,
    },
    left: '7%',
    top: '5%',
  },
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)',
  },
  legend: {
    data: [],
    itemWidth: 12,
    itemHeight: 12,
    bottom: 10,
  },
  color: ['#5BCCB8', '#EA8B00', '#3ba1ff', '#edbf00', '#00B091', '#D81E06', '#A2A2A2'],
  series: [
    {
      name: '',
      type: 'pie',
      radius: ['0', '50%'],
      center: ['50%', '50%'],
      label: {
        formatter: '{b} : {d}%',
      },
      labelLine: {
        length2: 0,
      },
      // itemStyle: {
      //   borderColor: '#fff',
      //   borderWidth: 2,
      // },
      data: [
        // {value: 335, name: '直接访问'},
        // {value: 310, name: '邮件营销'},
      ],
    },
  ],
}
